import React from "react";
import { Layout, Menu } from "antd";
import { HOME } from "../common/routes";
import {Route, Routes, useNavigate} from "react-router";
import { RosterUrl } from "../common/routes";
import { Roster } from "../common/pages/Roster";
import { G_DIVISIONS, G_AVAILABILITY, G_CONTACT, G_SCHEDULE, G_ASSIGNMENT, GoalieAssignUrl } from "./routes";
import { UserAuth } from "../common/interfaces";
import { useEnsuredUser } from "../common/contexts";
import { GoalieDashboard } from "./pages/GoalieDashboard";
import { GoaliePlacement } from "./pages/GoaliePlacement";
import { Availability } from "./pages/Availability";
import { Contact } from "./pages/Contact";
import { GoalieAssignmentSeason } from "./pages/GoalieAssignmentSeason";
import { GoalieSchedule } from "./pages/GoalieSchedule";
import { GoalieAssign } from "./pages/GoalieAssign";

export function GoalieApp() {
  const user = useEnsuredUser();
  const isCoordinator = user.authTypes.includes(UserAuth.GOALIE_COORDINATOR);
  let navigate = useNavigate();
  return (
    <Layout style={{ background: "white" }}>
      <Layout.Sider width={150}>
        <Menu mode={"inline"} theme={"dark"}>
          <Menu.Item
            key={"home"}
            onClick={() => navigate(HOME)}
          >
            Home
          </Menu.Item>
          <Menu.Item
            key={"schedule"}
            onClick={() => navigate(G_SCHEDULE)}
          >
            Schedule
          </Menu.Item>
          <Menu.Item
            key={"availability"}
            onClick={() => navigate(G_AVAILABILITY)}
          >
            Availability
          </Menu.Item>
          <Menu.Item
            key={"contact"}
            onClick={() => navigate(G_CONTACT)}
          >
            Contact
          </Menu.Item>
          {isCoordinator && (
            <Menu.ItemGroup title={<strong>Coordinator</strong>}>
              <Menu.Item
                key={"assignment"}
                onClick={() => navigate(G_ASSIGNMENT)}
              >
                Assign Goalies
              </Menu.Item>
              <Menu.Item
                key={"divisions"}
                onClick={() => navigate(G_DIVISIONS)}
              >
                Set Divisions
              </Menu.Item>
            </Menu.ItemGroup>
          )}
        </Menu>
      </Layout.Sider>
      <Layout.Content style={{ paddingLeft: 10 }}>
        <Routes>
          <Route path={HOME} element={<GoalieDashboard />} />
          <Route path={G_DIVISIONS} element={<GoaliePlacement />} />
          <Route path={G_SCHEDULE} element={<GoalieSchedule />} />
          <Route path={G_AVAILABILITY} element={<Availability />} />
          <Route path={G_CONTACT} element={<Contact />} />
          <Route path={G_ASSIGNMENT} element={<GoalieAssignmentSeason />} />
          <Route path={GoalieAssignUrl.pattern} element={<GoalieAssign />} />
          <Route path={RosterUrl.pattern} element={<Roster />} />
        </Routes>
      </Layout.Content>
    </Layout>
  );
}